import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';

export default function About() {
  return (
    <Layout>
      {/* Page Header */}
      <section className="relative overflow-hidden min-h-[280px] md:min-h-[360px] flex items-center bg-brand-dark">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40" style={{ backgroundImage: 'url(/assets/images/banner/about.jpg)' }}></div>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/30 to-brand/5"></div>
        <div className="container relative z-10 py-20">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-4">About</h2>
            <ul className="flex justify-center items-center gap-3 text-white/70 text-sm list-none p-0 m-0">
              <li><Link className="hover:text-brand transition-colors" to="/">Home</Link></li>
              <li><span className="text-white/40">/</span></li>
              <li className="text-brand">About</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="shape4 absolute top-0 right-0 opacity-10 pointer-events-none">
          <img src="/assets/images/shapes/about-v3-shape3.png" alt="#" />
        </div>
        <div className="shape5 absolute bottom-0 left-0 opacity-10 pointer-events-none">
          <img src="/assets/images/shapes/about-v3-shape4.png" alt="#" />
        </div>
        <div className="container relative z-10">
          <div className="row items-center">
            <div className="col-xl-5">
              <div className="relative mb-10 xl:mb-0">
                <div className="about-three__img1 wow fadeInLeft" data-wow-delay=".3s">
                  <img src="image4 (1).jpg" alt="#" className="w-full rounded-2xl shadow-lg" />
                </div>
                <div className="about-three__img2 wow fadeInUp absolute -bottom-6 -right-6 w-40 h-40 rounded-xl border-4 border-white shadow-lg overflow-hidden" data-wow-delay=".3s">
                  <div className="inner w-full h-full">
                    <img src="about.avif" alt="#" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-7">
              <div className="xl:pl-12">
                <div className="inline-flex items-center gap-2 mb-4">
                  <div className="w-8 h-8">
                    <img src="/assets/images/shapes/sec-title-shape.png" alt="#" className="w-full" />
                  </div>
                  <p className="text-brand text-xs font-bold uppercase tracking-widest"> Magizhini technology services</p>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark mb-5 leading-tight">
                  Premier Software Solutions And Tech Support
                </h2>
                <p className="text-gray-500 leading-relaxed mb-8">
                  Team of seasoned IT professionals with diverse expertise across various domains, enabling us to offer comprehensive solutions to meet all your IT needs.
                </p>

                <div className="row mb-8">
                  <div className="col-xl-7 col-lg-7 col-md-7">
                    <ul className="space-y-5 list-none p-0">
                      <li className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-brand flex items-center justify-center">
                          <span className="icon-buoy-help text-white text-lg"></span>
                        </div>
                        <div>
                          <h3 className="text-brand-dark font-bold font-heading mb-1">Tech Solution</h3>
                          <p className="text-gray-500 text-sm leading-relaxed">Flexibility and adaptability to requirements.</p>
                        </div>
                      </li>
                      <li className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-brand flex items-center justify-center">
                          <span className="icon-answer-call text-white text-lg"></span>
                        </div>
                        <div>
                          <h3 className="text-brand-dark font-bold font-heading mb-1">Quick Support</h3>
                          <p className="text-gray-500 text-sm leading-relaxed">Lightning-fast resolution times with our solutions.</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="col-xl-5 col-lg-5 col-md-5">
                    <div className="about-three__content-text2-progress mx-auto w-[200px] h-[200px] md:w-[220px] md:h-[220px] rounded-full overflow-hidden shadow-xl border border-white/10 flex flex-col items-center justify-center text-center gap-4 px-6">
                      <div className="progress-box">
                        <div className="graph-outer">
                          <input type="text" className="dial" data-fgcolor="#ffffff" data-bgcolor="#004175" data-width="80" data-height="80" data-linecap="normal" defaultValue="95" />
                          <div className="inner-text count-box">
                            <span className="count-text" data-stop="95" data-speed="2000"></span>
                            <span className="count-Parsent">%</span>
                          </div>
                        </div>
                      </div>
                      
                        
                    </div>
                    <h3 className="text-brand-dark font-bold font-heading text-sm">IT Project Solution</h3>
                  </div>
                </div>

                <ul className="space-y-3 mb-6 list-none p-0">
                  {[
                    'Ongoing support and maintenance services to ensure smooth and efficiency.',
                    'No matter the industry or size of your business, we deliver solutions that fit like a glove.',
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-brand-dark/80 text-sm leading-relaxed">
                      <span className="icon-check-circle text-brand flex-shrink-0 mt-0.5"></span>
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="inline-flex items-center gap-4 bg-brand/10 rounded-xl px-5 py-3 border border-brand/20">
                  <p className="text-brand-dark font-semibold text-sm">FOR YOUR IT BUSINESS, WE MADE THINGS EASIER</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="row gutter-y-30">
            {[
              { img: '/security.jpg', icon: 'icon-privacy', title: 'Digital Security', desc: "Protect against evolving cyber threats in today's digital landscape" },
              { img: '/trusted-partners.png', icon: 'icon-certified', title: 'Trusted Agency', desc: 'Trusted partner in excellence with integrity and reliability' },
              { img: '/OIP.webp', icon: 'icon-laptop', title: 'IT Outsourcing', desc: 'Technological needs with expertise and efficiency' },
            ].map(({ img, icon, title, desc }, i) => (
              <div className="col-xl-4 col-lg-4 wow animated fadeInUp" data-wow-delay={`${(i + 1) * 0.1}s`} key={i}>
                <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group">
                  <div className="relative">
                    <img src={img} alt={title} className="w-full h-52 object-cover" />
                    <div className="absolute bottom-4 right-4 w-12 h-12 rounded-full bg-brand flex items-center justify-center shadow-lg">
                      <span className={`${icon} text-white text-xl`}></span>
                    </div>
                  </div>
                  <div className="p-6 text-center">
                    <h2 className="text-xl font-bold font-heading text-brand-dark mb-2">
                      {title}
                    </h2>
                    <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="col-xl-6">
              <div className="relative mb-10 xl:mb-0">
                <img src="digital-transforming.jpg" alt="#" className="w-full rounded-2xl shadow-lg" />
              </div>
            </div>
            <div className="col-xl-6">
              <div className="xl:pl-12">
                <h2 className="text-3xl md:text-4xl font-bold font-heading text-brand-dark mb-6 leading-tight">
                  Leading the Digital<br />Transformation Revolution
                </h2>
                <p className="text-gray-500 leading-relaxed mb-8">
                  Experience the difference and unlock your full potential with our innovative technology solutions.
                </p>
                <div className="space-y-6">
                  {[
                    {
                      icon: 'icon-buoy-help',
                      title: 'Mission',
                      desc: 'Empowering businesses and individuals through innovative tech solutions, expert consultancy, and comprehensive training, driving digital transformation and success in today\'s dynamic digital world.',
                    },
                    {
                      icon: 'icon-buoy-help',
                      title: 'Vision',
                      desc: 'Leading global catalyst for growth and innovation, renowned for excellence in software, consultancy, training, and digital marketing, shaping the future of digital businesses worldwide.',
                    },
                  ].map(({ icon, title, desc }, i) => (
                    <div key={i} className="flex items-start gap-4 bg-gray-50 rounded-xl p-5 border border-gray-100">
                      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-brand flex items-center justify-center">
                        <span className={`${icon} text-white text-xl`}></span>
                      </div>
                      <div>
                        <h3 className="text-brand-dark font-bold font-heading mb-2">{title}</h3>
                        <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="w-full">
        <iframe
          src="https://maps.google.com/maps?q=44+Abelard+Ave,+Brampton,+ON+L6Y2K8,+Canada&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-72 md:h-96 border-0 block"
          allowFullScreen=""
          title=" Magizhini technology services office map"
        ></iframe>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
            <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url(/assets/images/shapes/contact-info-v1-bg0.png)', backgroundSize: 'cover' }}></div>
            <div className="row relative z-10">
              {[
                { iconClass: 'icon-location-filled', label: 'Address', content: ['44 Abelard Ave, Brampton, ON L6Y2K8, Canada.'] },
                { iconClass: 'icon-phone-auricular', label: 'Get In Touch', content: ['+1(647)-687-4226'], href: 'tel:+16476874226' },
                { iconClass: 'icon-email2', label: 'Quick Email us', content: ['magizhinitech@gmail.com'], href: ['mailto:magizhinitech@gmail.com'] },
              ].map(({ iconClass, label, content, href }, i) => (
                <div className="col-xl-4 col-lg-4" key={i}>
                  <div className="flex items-start gap-4 mb-8 xl:mb-0">
                    <div className="flex-shrink-0 w-14 h-14 rounded-full bg-brand flex items-center justify-center text-white text-xl">
                      <span className={iconClass}></span>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 uppercase tracking-widest font-medium mb-1">{label}</p>
                      {content.map((c, j) => (
                        href ? (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">
                            <a href={Array.isArray(href) ? href[j] : href} className="hover:text-brand transition-colors">{c}</a>
                          </h3>
                        ) : (
                          <h3 key={j} className="text-brand-dark font-semibold text-sm leading-relaxed">{c}</h3>
                        )
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}






